import { Controller } from "@hotwired/stimulus";

/**
 * GO4S Design System — Table / DataGrid.
 * Tri client sur les colonnes triables + sélection (tout / par ligne) avec
 * barre d'actions groupées. Spec : docs/design-system/REFERENCE.md §4
 */
export default class extends Controller {
  static targets = ["row", "rowCheck", "allCheck", "bulkbar", "count", "body", "sortBtn"];

  /* ---------- sélection ---------- */
  toggleAll() {
    const on = this.allCheckTarget.checked;
    this.rowCheckTargets.forEach((c) => (c.checked = on));
    this.refresh();
  }

  toggleRow() {
    this.refresh();
  }

  clear() {
    this.rowCheckTargets.forEach((c) => (c.checked = false));
    if (this.hasAllCheckTarget) this.allCheckTarget.checked = false;
    this.refresh();
  }

  refresh() {
    let n = 0;
    this.rowCheckTargets.forEach((c) => {
      const tr = c.closest("tr");
      if (tr) tr.setAttribute("aria-selected", String(c.checked));
      if (c.checked) n += 1;
    });
    if (this.hasAllCheckTarget) {
      this.allCheckTarget.checked = n > 0 && n === this.rowCheckTargets.length;
    }
    if (this.hasBulkbarTarget) this.bulkbarTarget.hidden = n === 0;
    if (this.hasCountTarget) this.countTarget.textContent = n;
  }

  /* ---------- tri ---------- */
  sort(event) {
    const btn = event.currentTarget;
    const dir = btn.dataset.dir === "asc" ? "desc" : "asc";
    this.sortBtnTargets.forEach((b) => {
      if (b !== btn) b.dataset.dir = "";
    });
    btn.dataset.dir = dir;

    const idx = Number(btn.dataset.index);
    const rows = Array.from(this.bodyTarget.querySelectorAll("tr"));
    rows.sort((a, b) => {
      const av = this.cellValue(a, idx);
      const bv = this.cellValue(b, idx);
      const na = parseFloat(String(av).replace(/[^\d.-]/g, ""));
      const nb = parseFloat(String(bv).replace(/[^\d.-]/g, ""));
      let cmp;
      if (!isNaN(na) && !isNaN(nb) && String(av).match(/\d/) && String(bv).match(/\d/)) {
        cmp = na - nb;
      } else {
        cmp = String(av).localeCompare(String(bv), "fr");
      }
      return dir === "asc" ? cmp : -cmp;
    });
    rows.forEach((r) => this.bodyTarget.appendChild(r));
  }

  cellValue(tr, idx) {
    const cell = tr.children[idx];
    if (!cell) return "";
    return cell.dataset.sort ?? cell.textContent.trim();
  }
}
